import { refs, booleanDataset } from '../modules/utils.js';

class PageProject extends HTMLElement {
  static get observedAttributes() {
    return [

    ];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    // console.log(name, newValue);
  }

  async connectedCallback() {
    await new Promise(resolve => setTimeout(resolve, 0));
    this.refs = refs(this);

    setTimeout(() => booleanDataset(this, 'active', true), 1);
  }
}

customElements.define('page-project', PageProject);
